const accordion = function() {
	document.querySelectorAll('.js-accordion').forEach($accordion => {
		$accordion.addEventListener('click', () => {
			$accordion.closest('.accordion').classList.toggle('is-active');
		});
	});

	document.querySelectorAll('.js-accordion-trigger').forEach($trigger => {
		const $accordion = document.querySelector(`#${$trigger.getAttribute('data-accordion-id')}`);
		if (!$accordion) return;
		$trigger.addEventListener('click', () => {
			$accordion.classList.add('is-active');
		});
	});
};

module.exports = accordion;
